/** @flow */

import { transformFilters, OPERATORS } from "@transformers/request";

export const transformHierarchyChangelogFilters = (filters: Object) => {
  let transformedFilters = transformFilters(
    {
      operation: (filters || {}).operation,
      createdBy: (filters || {}).createdBy,
      createdAt: (filters || {}).from,
    },
    {
      operation: OPERATORS.EQUALS,
      created_by: OPERATORS.EQUALS,
      created_at: OPERATORS.GREATER_THAN,
    },
  );

  const transformedRangeFiltersHelper = transformFilters(
    {
      createdAt: (filters || {}).to,
    },
    {
      created_at: OPERATORS.LESS_THAN,
    },
  );

  transformedFilters += `,${transformedRangeFiltersHelper}`;
  return transformedFilters;
};
